/**
 * Tier Configuration — Fase 1 (Free + Pro)
 * Costanti centralizzate per i piani dealer
 */

import type { DealerTier } from '@/types/subscription';

/** Trial duration in days */
export const TRIAL_DAYS = 30;

/** Bonus GTS points for Pro dealers in priority ranking (Fase 2) */
export const TIER_BOOST_POINTS = 10;

/** Bonus engagement score points for Pro dealers in GTS calculation */
export const GTS_ENGAGEMENT_BONUS = 10;

export interface TierConfig {
  tier: DealerTier;
  label: string;
  priceMonthly: number;
  creditsMonthly: number;
  welcomeCredits: number;
  badgeLabel: string | null;
  hasHighlightedListing: boolean;
  hasPriceLock: boolean;
  hasAnalytics: boolean;
}

/** Stripe IDs for Gildy Pro subscription */
export const STRIPE_PRO = {
  productId: 'prod_U93mz5TP6CUrTq',
  priceId: 'price_1TAleh3BgRWftRpdBOunPUeh',
} as const;

export const TIER_CONFIGS: Record<DealerTier, TierConfig> = {
  free: {
    tier: 'free',
    label: 'Free',
    priceMonthly: 0,
    creditsMonthly: 0,
    welcomeCredits: 100,
    
    badgeLabel: null,
    hasHighlightedListing: false,
    hasPriceLock: true,
    hasAnalytics: false,
  },
  pro: {
    tier: 'pro',
    label: 'Pro',
    priceMonthly: 49,
    creditsMonthly: 50,
    welcomeCredits: 100,
    
    badgeLabel: 'Verificato',
    hasHighlightedListing: true,
    hasPriceLock: true,
    hasAnalytics: true,
  },
};

export const getTierConfig = (tier: DealerTier): TierConfig => {
  return TIER_CONFIGS[tier] || TIER_CONFIGS.free;
};

export const getTierBadgeLabel = (tier: DealerTier): string | null => {
  return TIER_CONFIGS[tier]?.badgeLabel || null;
};
